import React from "react";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";

const About = () => {
  return (
    <div
      name="about"
      id="about"
      className="w-full h-screen bg-[#0a192f] text-white"
    >
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="py-20 px-16 rounded-md bg-cyan-800 flex flex-col justify-center items-center w-5/6 max-w-[1000px]">
          <div className="w-full grid grid-cols-2 gap-16 mb-6">
            <div className="pb-8">
              <p className="text-4xl font-bold inline border-b-4 border-cyan-500">
                About
              </p>
            </div>
            <div></div>
          </div>
          <div className="w-full grid sm:grid-cols-2 gap-16">
            <div className="sm:text-right text-4xl font-bold leading-snug">
              <p>I'm Joel! I am based in Greenville, SC.</p>
            </div>
            <div className="text-xl leading-loose">
              <p>
                {" "}
                I work as an Information Engineer at{" "}
                <a
                  href="https://www.starburst.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  style={{
                    textDecoration: "underline",
                    textDecorationThickness: "0.2em",
                    textUnderlineOffset: "0.2em",
                  }}
                >
                  Starburst Data
                  <FaArrowUpRightFromSquare className="inline ml-1 text-amber-500" />
                </a>{" "}
                and contribute to documentation for the{" "}
                <a
                  href="https://trino.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  style={{
                    textDecoration: "underline",
                    textDecorationThickness: "0.2em",
                    textUnderlineOffset: "0.2em",
                  }}
                >
                  Trino
                  <FaArrowUpRightFromSquare className="inline ml-1 text-amber-500" />
                </a>{" "}
                OSS project.
              </p>
            </div>
          </div>
          <div className="w-full mt-8 text-base leading-relaxed text-gray-200">
            <p>
              I try to understand who I'm writing for before I write anything. Good documentation works the same way good product design does:
              it has to fit the user's mental model, not just describe what the system does. In practice that means mapping out workflows first, 
              then figuring out what content structure makes sense. I've worked on AI feature documentation, configuration references, connector documentation, 
              and full documentation set migrations, and I collaborate with engineering teams throughout.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
